import React, { useState } from 'react';
import useCommonStore, { setIsLoading } from 'store/common';
import { Button, Stack, Modal } from 'react-bootstrap';
import { useGetStripPaymentURLMutation, useGetSubscriptionsListQuery } from 'services';
import { getCurrencySymbol } from 'utils';
import { APP_BASE_URL } from 'constants/index';
import toast from 'react-hot-toast';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const SubscriptionModal: React.FC<any> = () => {
	const { translate } = useTranslate();
	const { modalConfig = {}, hideCommonModal }: any = useCommonStore((state) => state);
	const { mutateAsync: stripePaymentURL } = useGetStripPaymentURLMutation();

	const [selectedPlan, setSelectedPlan] = useState('');
	const [planType, setPlanType] = useState('one_time');
	const { data: planList = [] } = useGetSubscriptionsListQuery(planType);

	const buySubscription = () => {
		setIsLoading(true);
		sessionStorage.setItem('redirectURL', location?.pathname?.replace(APP_BASE_URL, ''));
		stripePaymentURL({ planId: selectedPlan })
			.then((res: any) => {
				if (res?.success && res?.data?.url) {
					window.open(res?.data?.url, '_self');
				}
			})
			.finally(() => setIsLoading(false));
	};

	const onPurchaseClick = () => {
		if (selectedPlan) {
			buySubscription();
		} else {
			toast.error(translate('Validation.selectPlan'));
		}
	};

	return (
		<Modal.Body>
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => (modalConfig?.onClose ? modalConfig?.onClose() : hideCommonModal())}
			>
				<i className="ri-close-line"></i>
			</Button>

			<div className="upgrade-subscription-plan">
				<div className="upgrade-subscription-plan-title text-center">
					{/* <h4 className="fw-bold mb-1">{translate('Plan.buyPlan')}</h4> */}
					<p className="mb-0">
						{parse(sanitizeHtml(translate('Plan.choosePlansThatWorksBestForYou')))}
					</p>
				</div>

				{planList?.length > 0 && (
					<Stack className="upgrade-subscription-plan-content">
						{planList?.map((plan: any, index: number) => (
							<div
								key={index}
								className={`upgrade-plan-box ${selectedPlan && Number(selectedPlan) === Number(plan?.id) ? 'selected-plan' : ''}`}
								onClick={() => setSelectedPlan(plan?.id)}
							>
								<div className="d-flex align-items-center justify-content-between mb-1">
									<h6 className="mb-0">{plan?.title}</h6>
									{plan?.price && (
										<h6 className="mb-0">
											{plan?.default_currency && getCurrencySymbol(plan.default_currency)}
											{plan.price}
										</h6>
									)}
								</div>
								<p className="mb-0">{plan?.description}</p>
							</div>
						))}
					</Stack>
				)}

				<div className="upgrade-subscription-plan-action d-flex flex-column flex-sm-row align-items-center justify-content-between">
					<div className="d-flex align-items-center gap-2">
						<i className="ri-lock-line"></i>
						<p className="mb-0">{translate('Plan.paymentSecuredByStripe')}</p>
					</div>
					<div className="d-flex align-items-center gap-2">
						<Button
							className="transparent-btn rounded-pill"
							onClick={() => (modalConfig?.onClose ? modalConfig?.onClose() : hideCommonModal())}
						>
							{translate('Extras.cancel')}
						</Button>
						<Button onClick={() => onPurchaseClick()} className="filled-btn rounded-pill">
							{translate('Extras.upgradeNow')}
						</Button>
					</div>
				</div>
			</div>
		</Modal.Body>
	);
};

export default SubscriptionModal;
